import * as React from 'react'
import { useState } from 'react'

import { Icon } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'
import includes from 'lodash/includes'
import sortBy from 'lodash/sortBy'
import uniqBy from 'lodash/uniqBy'
import without from 'lodash/without'

import { observer } from 'mobx-react'

import LabeledFancyCheckbox from 'modules/core/components/Inputs/LabeledFancyCheckbox'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type PublicHoliday from 'modules/locations/store/models/PublicHoliday'

import styles from './index.module.css'

type IgnoredHolidays = string[]

interface Props {
  onChange: (ignoredHolidays: IgnoredHolidays) => void
  holidays: PublicHoliday[]
  country: string | null | undefined
}

const Days = (props: Props) => {
  const { holidays, country, onChange } = props
  const [ignoredHolidays, setIgnoredHolidays] = useState<string[]>([])

  const sortedHolidays = sortBy(
    uniqBy(holidays, (holiday) => holiday.get('date')),
    (holiday) => holiday.get('date')
  )

  const handleChange = (holiday: PublicHoliday) => {
    const id = String(holiday.attributes.id)
    const checked = ignoredHolidays.includes(id)
    let selectedHolidays: string[]

    if (checked) {
      selectedHolidays = without(ignoredHolidays, id)
    } else {
      selectedHolidays = ignoredHolidays.concat([id])
    }

    setIgnoredHolidays(selectedHolidays)
    onChange(selectedHolidays)
  }

  const renderPublicHoliday = (holiday: PublicHoliday) => {
    const id = String(holiday.attributes.id)
    const date = stringToDate(holiday.attributes.date, 'backend').format('ll')

    const label = (
      <div className={styles.label}>
        <span className={styles.summary}>{holiday.attributes.summary}</span>—
        <span className={styles.date}>{date}</span>
      </div>
    )

    const field = new Field(!includes(ignoredHolidays, id), 'boolean')

    return (
      <li key={id} className={styles.holidays__item}>
        <LabeledFancyCheckbox label={label} onChange={() => handleChange(holiday)} field={field} />
      </li>
    )
  }

  if (!country) return null

  if (!holidays.length) {
    return (
      <div className={styles.notFound}>
        <div className={styles.illustration}>
          <Icon.Large icon="calendar" />
        </div>
        <div className={styles.text}>{i18n.t('settings.time_off.public_holiday_blank_slate')}</div>
      </div>
    )
  }

  return (
    <ul className={styles.holidays}>
      {sortedHolidays.map((holiday) => renderPublicHoliday(holiday))}
    </ul>
  )
}

export default observer(Days)
